module.exports = {
	"text/vtt": [
		"vtt"
	],
	"application/x-chrome-extension": [
		"crx"
	],
	"text/x-component": [
		"htc"
	],
	"text/cache-manifest": [
		"manifest"
	],
	"application/octet-stream": [
		"buffer"
	],
	"application/mp4": [
		"m4p"
	],
	"audio/mp4": [
		"m4a"
	],
	"video/MP2T": [
		"ts"
	],
	"application/x-web-app-manifest+json": [
		"webapp"
	],
	"text/x-lua": [
		"lua"
	],
	"application/x-lua-bytecode": [
		"luac"
	],
	"text/x-markdown": [
		"markdown",
		"md",
		"mkd"
	],
	"text/plain": [
		"ini"
	],
	"application/dash+xml": [
		"mdp"
	],
	"font/opentype": [
		"otf"
	],
	"application/json": [
		"map"
	],
	"application/xml": [
		"xsd"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/fhir.js/~/mime-types/lib/node.json
// module id = 1242
// module chunks = 0